import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  Stack,
  Typography,
  LinearProgress
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {AlertSettingsRecipients} from './AlertSettingsRecipients';
import {useNotificationSettings} from '../hooks/useNotificationSettings';
import {EmailItem} from '../types';

interface NotificationSettingsDialogProps {
  open: boolean;
  onClose: () => void;
  alertId: string;
  alertName?: string;
  emails: EmailItem[];
  reload: () => Promise<void>;
}

export const NotificationSettingsDialog = ({
  open,
  onClose,
  alertId,
  alertName,
  emails,
  reload
}: NotificationSettingsDialogProps) => {
  const {t} = useTranslation();

  const {
    notifications,
    isLoading,
    handleInlineSendSettingChange,
    handleInlineDelete,
    handleInlineAdd,
    newEmail,
    setNewEmail,
    newReceiveMailType,
    setNewReceiveMailType,
    addDialogOpen,
    handleOpenAddDialog,
    handleCloseAddDialog,
    selectedIndices,
    handleToggleSelect,
    handleToggleSelectAll,
    handleBatchDelete,
    handleBatchSendSettingChange,
    onSave
  } = useNotificationSettings({alertId, open, emails, reload});

  const handleSaveAndClose = async () => {
    await onSave();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography variant="h6">
          {t('通知先設定')}
          {alertName && ` : ${alertName}`}
        </Typography>
      </DialogTitle>

      {isLoading && (
        <Backdrop sx={{zIndex: 9999}} open={true}>
          <Stack sx={{width: '50%'}} spacing={2} textAlign={'center'}>
            <Typography variant="h4" color="secondary">
              Loading..
            </Typography>
            <LinearProgress color="secondary" />
          </Stack>
        </Backdrop>
      )}

      <DialogContent>
        <AlertSettingsRecipients
          notifications={notifications}
          emails={emails}
          alertId={alertId}
          t={t}
          handleInlineSendSettingChange={handleInlineSendSettingChange}
          handleInlineDelete={handleInlineDelete}
          addDialogOpen={addDialogOpen}
          handleOpenAddDialog={handleOpenAddDialog}
          handleCloseAddDialog={handleCloseAddDialog}
          handleInlineAdd={handleInlineAdd}
          newEmail={newEmail}
          setNewEmail={setNewEmail}
          newReceiveMailType={newReceiveMailType}
          setNewReceiveMailType={setNewReceiveMailType}
          selectedIndices={selectedIndices}
          handleToggleSelect={handleToggleSelect}
          handleToggleSelectAll={handleToggleSelectAll}
          handleBatchDelete={handleBatchDelete}
          handleBatchSendSettingChange={handleBatchSendSettingChange}
        />
      </DialogContent>

      <DialogActions sx={{padding: 2}}>
        <Button variant="contained" color="primary" onClick={handleSaveAndClose}>
          {t('保存')}
        </Button>
        <Button variant="outlined" color="primary" onClick={onClose}>
          {t('保存せず戻る')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
